import React, {useState, useEffect} from 'react';
import './issues.scss';
import Pagination from '../pagination/pagination';

export default function Issues(params) {

  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [items, setItems] = useState([]);
  const [issues, setIssues] = useState([]);
  const itemsPerPage = 10;

  function handleCloseModal() {
    setShowModal(false); 
    setCurrentPage(1);
  };
  const handleShowModal = () => setShowModal(true);
  const handlePreviousPage = () => setCurrentPage(currentPage - 1);
  const handleNextPage = () => setCurrentPage(currentPage + 1);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedList = items.slice(startIndex, endIndex);

  const getTotalIssues = items => {
    return items.reduce((acc, item) => {
      return acc + item.issues.length;
    }, 0);
  };

  function filterByIssueType(issues, issueType) {
      return issues.filter(function(issue) {
        return issue.custom_fields.breakdown_or_accident === issueType;
      });
    }
  function filterDuplicates(objects, key) {
      const seen = new Set();
      return objects.filter(object => {
        const value = object[key];
        if (seen.has(value)) {
          return false;
        } else {
          seen.add(value);
          return true;
        }
      });
    }

  function mergeArrays(vehicles, issues) {
      return vehicles.map(vehicle => {
        const matchingIssues = issues.filter((issue) => issue.asset.name === vehicle.name);
        return matchingIssues.length ? { ...vehicle, issues: matchingIssues } : null;
      }).filter(vehicle => vehicle);
    }


  const processOrders = (vehicles, orders) => {
    return vehicles.map((vehicle) => {
      const ordersForVehicle = orders
        .filter((order) => order.vehicle_name === vehicle.name)
        .map((order) => ({
          order_number: order.number.replace(/#/g, ''),
          url: `https://secure.fleetio.com/${process.env.REACT_APP_FLEETIO_ACCOUNT_TOKEN}/work_orders/${order.number.replace(/#/g, '')}`,
        }));

      return {
        ...vehicle,
        orders: ordersForVehicle,
      };
    });
  };
    
  useEffect(()=>{
    setCurrentPage(1);
  }, [params['depot']])

  useEffect(() => {
      async function fetchData() {
          const deduplicatedIssues = await filterDuplicates(params['issues'] || [], 'id');
          const data = await filterByIssueType(deduplicatedIssues, params['type']);
          setIssues(data);
          setItems(mergeArrays(params['vehicles'], data));
          
      }
      fetchData();
  }, [params]);

  const tone = params['type'].toLowerCase().replace(/\s+/g, '-');

  function renderVehicleRow(item) {
    return (
      <li className='vehicle-row' key={item.id}>
        <a className='vehicle-name' target='_blank' rel='noreferrer' href={`https://secure.fleetio.com/${process.env.REACT_APP_FLEETIO_ACCOUNT_TOKEN}/vehicles/${item.id}`}>{item.name}</a>
        <span className='issue-links'>
          {item.issues.map((issue) => (
            <a className='issue-link' key={issue.id} target='_blank' rel='noreferrer' href={`https://secure.fleetio.com/${process.env.REACT_APP_FLEETIO_ACCOUNT_TOKEN}/issues/${issue.number}`}>Issue {issue.number}</a>
          ))}
        </span>
      </li>
    );
  }

  return (
    <div className='box'>
      <div className='container'>
        <div className='card-header'>
          <h2>{params['type']}</h2>
          <span className={`count-pill tone-${tone}`}>{getTotalIssues(items)}</span>
        </div>
        {params['issues'] === null && <p className='empty-note'>Loading issues...</p>}
        <ul className='vehicle-list'>
          {items.slice(0, 5).map((item) => renderVehicleRow(item))}
        </ul>
        {items.length > 5 && (
          <button className='show-modal-button' onClick={handleShowModal}>
            Show all {items.length}
          </button>
        )}
        {showModal && (
          <div className='modal-overlay'>
            <div className='modal'>
              <div className='modal-header'>
                <div className='card-header'>
                  <h2>{params['type']}</h2>
                  <span className={`count-pill tone-${tone}`}>{getTotalIssues(items)}</span>
                </div>
                <button className='close-button' onClick={handleCloseModal}>
                  &times;
                </button>
              </div>
              <ul className='modal-body vehicle-list'>
                {paginatedList.map((item) => renderVehicleRow(item))}
              </ul>
              <div className='modal-footer'>
                <div className='footer-slot'>
                  {currentPage > 1 && (
                    <button className='previous-button' onClick={handlePreviousPage}>
                      Previous
                    </button>
                  )}
                </div>
                {(currentPage > 1 || endIndex < items.length) && (
                  <Pagination totalPages={Math.ceil(items.length / 10)} currentPage={currentPage}/>
                )}
                <div className='footer-slot footer-slot--right'>
                  {endIndex < items.length && (
                    <button className='next-button' onClick={handleNextPage}>
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );




            }
